/**
 * Okta Authentication Configuration
 * 
 * This file contains the Okta authentication settings for the application.
 * Environment variables should be set in .env file or deployment environment.
 * 
 * Production Domain: https://autoapproval.prajnagpt.net
 * Production Redirect URI: https://autoapproval.prajnagpt.net/login/callback
 */

export const oktaConfig = {
  // Okta domain and issuer URL
  // Set via REACT_APP_OKTA_ISSUER environment variable
  issuer: process.env.REACT_APP_OKTA_ISSUER || 'https://your-domain.okta.com/oauth2/default',
  
  // Okta application client ID
  // Set via REACT_APP_OKTA_CLIENT_ID environment variable
  clientId: process.env.REACT_APP_OKTA_CLIENT_ID || 'your-client-id',
  
  // Redirect URI after login (must be registered in Okta app)
  // Development: http://localhost:3000/login/callback
  // Production: https://autoapproval.prajnagpt.net/login/callback
  // Falls back to current origin if not set (useful for dynamic environments)
  redirectUri: process.env.REACT_APP_OKTA_REDIRECT_URI || `${window.location.origin}/login/callback`,
  
  // Scopes to request from Okta
  scopes: ['openid', 'profile', 'email'],
  
  // Enable PKCE (Proof Key for Code Exchange) for security
  pkce: true,
  
  // Disable HTTPS requirement for local development (DO NOT USE IN PRODUCTION)
  disableHttpsCheck: process.env.NODE_ENV === 'development',
  
  // Token storage location
  tokenManager: {
    storage: 'localStorage'
  }
};

/**
 * Okta Auth instance configuration
 * Pass this to OktaAuth constructor
 */
export const getOktaAuthConfig = () => {
  return {
    issuer: oktaConfig.issuer,
    clientId: oktaConfig.clientId,
    redirectUri: oktaConfig.redirectUri,
    scopes: oktaConfig.scopes,
    pkce: oktaConfig.pkce,
    disableHttpsCheck: oktaConfig.disableHttpsCheck,
    tokenManager: oktaConfig.tokenManager
  };
};

/**
 * Validate Okta configuration
 * Throws error if required values are missing
 */
export const validateOktaConfig = () => {
  const errors = [];
  
  if (!process.env.REACT_APP_OKTA_ISSUER) {
    errors.push('REACT_APP_OKTA_ISSUER is not set');
  }
  
  if (!process.env.REACT_APP_OKTA_CLIENT_ID) {
    errors.push('REACT_APP_OKTA_CLIENT_ID is not set');
  }
  
  if (errors.length > 0) {
    console.error('Okta Configuration Errors:', errors);
    if (process.env.NODE_ENV === 'production') {
      throw new Error(`Okta configuration is incomplete: ${errors.join(', ')}`);
    } else {
      console.warn('⚠️  Using default Okta configuration for development');
    }
  }
};
